
export default function Rating({rating, classes}) {

    const stars = [0, 0, 0, 0, 0];
    const full = Math.floor(rating / 1);
    const partial = rating % 1;

    //last star filled partially, prior are filled, rest are empty
    for (let i = 0; i < full; i++) {
        if (full === i + 1) stars[i] = partial;
        else stars[i] = 1;
    }
    
    return (
        <div className={`stars-container ${classes}`}
            style={{
                '--star-1': stars[0],
                '--star-2': stars[1],
                '--star-3': stars[2],
                '--star-4': stars[3],
                '--star-5': stars[4]
            }}>
            <span className="star star-1"></span>
            <span className="star star-2"></span>
            <span className="star star-3"></span>
            <span className="star star-4"></span>
            <span className="star star-5"></span>
        </div>
    )

}
